/**
 * Puuki.fi — Universaali tuoteoptio-lomake
 *
 * Lukee JSON-konfiguraation data-po-config -attribuutista ja hallinnoi:
 * - Tilanhallinnan (valitut arvot)
 * - Ehdollisen logiikan (kenttien näyttö/piilotus)
 * - Variantin vaihdon (lisähintalogiikka)
 * - Piilotettujen property-inputtien synkronoinnin
 * - Merkkimäärälaskurit
 * - Lomakevalidoinnin
 * - Tiedostojen latauksen
 */
(function () {
  'use strict';

  var a11ySequence = 0;

  function initAll() {
    var containers = document.querySelectorAll('.po[data-po-config]');
    for (var i = 0; i < containers.length; i++) {
      if (!containers[i]._poInit) {
        containers[i]._poInit = true;
        initInstance(containers[i]);
      }
    }
  }

  function initInstance(container) {
    var config, state = {}, productVariants = null, multiState = {};

    try {
      config = JSON.parse(container.dataset.poConfig);
    } catch (e) {
      console.error('PO: konfiguraation parsinta epäonnistui', e);
      return;
    }
    if (!config || !config.fields) return;

    if (window.PuukiPoProfiles) {
      var profile = window.PuukiPoProfiles.configFor(container, config, FONT_PRESETS);
      if (profile) {
        config = profile;
        container.innerHTML = '';
        container.dataset.poConfig = JSON.stringify(config);
      }
    }

    // Resolvoi presetit ennen renderöintiä
    config.fields.forEach(function (f) {
      if (f.type === 'radio_color' && f.colorPreset && COLOR_PRESETS[f.colorPreset]) {
        f.options = COLOR_PRESETS[f.colorPreset];
      }
      // Merkitse estetyt värivaihtoehdot (disabledValues) — ei valittavissa.
      // Kloonataan optio jotta jaettu COLOR_PRESETS-objekti ei muutu.
      if (f.type === 'radio_color' && f.options && f.disabledValues && f.disabledValues.length) {
        f.options = f.options.map(function (o) {
          return f.disabledValues.indexOf(o.value) !== -1
            ? Object.assign({}, o, { disabled: true })
            : o;
        });
      }
    });

    // Lisää vakiokentät jos niitä ei ole: liite (ennen lisätiedot) ja lisätiedot (loppuun)
    injectDefaultFields();

    // Renderöi kentät: kokonaan JS:llä jos Liquid ei renderöinyt, tai täydennä tyhjät
    if (container.children.length === 0) {
      renderFields();
    } else {
      // Liquid renderöi osittain — täydennä tyhjät + lisää puuttuvat kentät
      fillEmptyColorPresets();
      renderMissingFields();
    }

    // Alusta tila DOM:sta — selain voi palauttaa lomakekontrollien tilan
    // (back/forward) ilman change-eventtejä; kova false/'' jättäisi ehdolliset
    // kentät piiloon vaikka toggle näkyy valittuna (vrt. tilaus #1424).
    config.fields.forEach(function (f) {
      if (f.type === 'toggle') {
        var cb0 = container.querySelector('[data-po-input="' + f.id + '"] .po__toggle-input');
        state[f.id] = !!(cb0 && cb0.checked);
      } else if (f.type === 'text' || f.type === 'textarea' || f.type === 'select') {
        var el0 = container.querySelector('[data-po-input="' + f.id + '"]');
        state[f.id] = (el0 && el0.value) || '';
      } else {
        state[f.id] = '';
      }
    });

    injectPoStyles();
    applyDefaults();
    loadProductVariants();
    bindEvents();
    initPersonalizedTexts();
    initMultiSelects();
    evaluateConditions();
    syncAllProperties();
    applyUiHides();
    moveQuantityAfterOptions();
    if (config.movePickerToEnd) moveVariantPickerAfterOptions();
    recomputeMultiSelects();

    if (window.PuukiPoProfiles) window.PuukiPoProfiles.attach(container, config);
    linkFieldLabels();

    var form = container.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!validateForm()) { e.preventDefault(); e.stopPropagation(); }
      });
    }

    function linkFieldLabels() {
      var prefix = 'PuukiOption-' + (++a11ySequence) + '-';
      container.querySelectorAll('.po__field').forEach(function (field, fi) {
        var controls = field.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"]):not([type="file"]), textarea, select');
        controls.forEach(function (control, ci) {
          var line = control.closest('.po__pt-line');
          var label = (line || field).querySelector('.po__label');
          if (!label) return;
          if (label.tagName !== 'LABEL') {
            var replacement = document.createElement('label');
            replacement.className = label.className;
            replacement.innerHTML = label.innerHTML;
            label.replaceWith(replacement);
            label = replacement;
          }
          if (!control.id) control.id = prefix + fi + '-' + ci;
          label.htmlFor = control.id;
          var described = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
          (line || field).querySelectorAll('.po__help, .po__char-count').forEach(function (help, hi) {
            if (!help.id) help.id = control.id + '-help-' + hi;
            if (described.indexOf(help.id) === -1) described.push(help.id);
          });
          if (described.length) control.setAttribute('aria-describedby', described.join(' '));
        });
        var group = field.querySelector('.po__radio-group, .po__swatch-group');
        var groupLabel = field.querySelector('.po__label');
        if (group && groupLabel) {
          if (!groupLabel.id) groupLabel.id = prefix + fi + '-label';
          group.setAttribute('role', 'group');
          group.setAttribute('aria-labelledby', groupLabel.id);
        }
      });
    }

    // --- Renderöinti (JS-fallback kun Liquid ei ole käytettävissä) ---

    function renderFields() {
      var html = '';
      config.fields.forEach(function (f) {
        var condAttr = f.condition ? " data-po-condition='" + escapeAttr(JSON.stringify(f.condition)) + "' style=\"display:none;\"" : '';
        html += '<div class="po__field" data-po-field="' + f.id + '" data-po-type="' + f.type + '"' + condAttr + '>';

        // Label (personalized_text renderöi oman labelin sisäisesti)
        if (f.label && f.type !== 'personalized_text') {
          html += '<span class="po__label">' + esc(f.label);
          if (f.required) html += '<span class="po__required">*</span>';
          html += '</span>';
        }
        if (f.helpText && f.type !== 'personalized_text') {
          html += '<span class="po__help">' + esc(f.helpText) + '</span>';
        }

        // Field body
        if (f.type === 'radio_button') {
          html += '<div class="po__radio-group" data-po-input="' + f.id + '">';
          (f.options || []).forEach(function (o) {
            html += '<button type="button" class="po__radio-btn" data-po-value="' + escapeAttr(o.value) + '"';
            if (o.variantId) html += ' data-po-variant="' + o.variantId + '"';
            if (o.priceAddon) html += ' data-po-price-addon="' + o.priceAddon + '"';
            html += '>' + esc(o.label) + '</button>';
          });
          html += '</div>';

        } else if (f.type === 'radio_image') {
          html += '<div class="po__swatch-group po__swatch-group--image" data-po-input="' + f.id + '">';
          (f.options || []).forEach(function (o) {
            html += '<button type="button" class="po__swatch po__swatch--image" data-po-value="' + escapeAttr(o.value) + '"';
            if (o.variantId) html += ' data-po-variant="' + o.variantId + '"';
            if (o.priceAddon) html += ' data-po-price-addon="' + o.priceAddon + '"';
            html += ' title="' + escapeAttr(o.label) + '">';
            if (o.image) {
              html += '<img src="' + escapeAttr(o.image) + '" alt="' + escapeAttr(o.label) + '" loading="lazy" width="80" height="80">';
            } else {
              html += '<span class="po__swatch-label">' + esc(o.label) + '</span>';
            }
            html += '<span class="po__swatch-name">' + esc(o.label) + '</span></button>';
          });
          html += '</div>';

        } else if (f.type === 'radio_color') {
          html += '<div class="po__swatch-group po__swatch-group--color" data-po-input="' + f.id + '">';
          (f.options || []).forEach(function (o) {
            var disCls = o.disabled ? ' po__swatch--disabled' : '';
            var disAttr = o.disabled ? ' disabled aria-disabled="true"' : '';
            var disTitle = o.disabled ? (o.label + ' — ei tällä hetkellä saatavilla') : o.label;
            html += '<button type="button" class="po__swatch po__swatch--color' + disCls + '" data-po-value="' + escapeAttr(o.value) + '"' + disAttr;
            if (o.variantId) html += ' data-po-variant="' + o.variantId + '"';
            html += ' title="' + escapeAttr(disTitle) + '" style="--swatch-color:' + (o.color || '#ccc') + '">';
            html += '<span class="po__color-circle"></span>';
            html += '<span class="po__swatch-name">' + esc(o.label) + '</span></button>';
          });
          html += '</div>';

        } else if (f.type === 'text') {
          html += '<div class="po__text-wrap">';
          html += '<input type="text" class="po__input" data-po-input="' + f.id + '" maxlength="' + (f.maxLength || 100) + '"';
          html += ' placeholder="' + escapeAttr(f.placeholder || '') + '" autocomplete="off"';
          if (f.required) html += ' required';
          html += '>';
          if (f.maxLength) html += '<div class="po__char-count" data-po-count="' + f.id + '">0/' + f.maxLength + '</div>';
          html += '</div>';

        } else if (f.type === 'textarea') {
          html += '<div class="po__text-wrap">';
          html += '<textarea class="po__textarea" data-po-input="' + f.id + '" maxlength="' + (f.maxLength || 200) + '"';
          html += ' rows="' + (f.rows || 3) + '" placeholder="' + escapeAttr(f.placeholder || '') + '"';
          if (f.required) html += ' required';
          html += '></textarea>';
          if (f.maxLength) html += '<div class="po__char-count" data-po-count="' + f.id + '">0/' + f.maxLength + '</div>';
          html += '</div>';

        } else if (f.type === 'select') {
          html += '<div class="po__select-wrap">';
          html += '<select class="po__select" data-po-input="' + f.id + '">';
          html += '<option value="" disabled selected>' + esc(f.placeholder || 'Valitse...') + '</option>';
          (f.options || []).forEach(function (o) {
            html += '<option value="' + escapeAttr(o.value) + '"';
            if (o.variantId) html += ' data-po-variant="' + o.variantId + '"';
            if (o.priceAddon) html += ' data-po-price-addon="' + o.priceAddon + '"';
            html += '>' + esc(o.label) + '</option>';
          });
          html += '</select></div>';

        } else if (f.type === 'toggle') {
          html += '<label class="po__toggle" data-po-input="' + f.id + '">';
          html += '<input type="checkbox" class="po__toggle-input"';
          if (f.priceAddon) html += ' data-po-price-addon="' + f.priceAddon + '"';
          html += '>';
          html += '<span class="po__toggle-track"><span class="po__toggle-thumb"></span></span>';
          html += '<span class="po__toggle-label">' + esc(f.toggleLabel || 'Kyllä') + '</span>';
          html += '</label>';

        } else if (f.type === 'personalized_text') {
          html += renderPersonalizedTextHTML(f);

        } else if (f.type === 'file_upload') {
          html += renderFileUploadHTML(f);
        }

        // Hidden property — EI file_upload-kentille (file input on itse property)
        if (f.propertyName && f.type !== 'file_upload') {
          html += '<input type="hidden" name="properties[' + escapeAttr(f.propertyName) + ']" value="" data-po-property="' + f.id + '">';
        }
        // Fontti-property (personalized_text)
        if (f.fontPropertyName) {
          html += '<input type="hidden" name="properties[' + escapeAttr(f.fontPropertyName) + ']" value="" data-po-property="' + f.id + '__font">';
        }

        html += '</div>';
      });
      container.innerHTML = html;
    }

    // --- File Upload HTML (N slottia, jokainen oma properties[]-nimi) ---

    function renderFileUploadHTML(f) {
      var maxFiles = f.maxFiles || 1;
      var propBase = f.propertyName || f.label || 'Liite';
      var accept = escapeAttr(f.accept || '.jpg,.png,.jpeg,.svg');
      var hint = esc(f.uploadHint || 'Tuetut muodot: jpg, png, svg');
      var html = '<div class="po__upload" data-po-input="' + f.id + '" data-po-max-files="' + maxFiles + '">';
      for (var i = 1; i <= maxFiles; i++) {
        var slotProp = i === 1 ? propBase : propBase + ' ' + i;
        html += '<label class="po__upload-area" data-po-slot="' + i + '">';
        html += '<input type="file" class="po__upload-input" name="properties[' + escapeAttr(slotProp) + ']" accept="' + accept + '">';
        html += '<span class="po__upload-btn">' + (maxFiles > 1 ? 'Valitse tiedosto ' + i : 'Valitse tiedosto') + '</span>';
        html += '<span class="po__upload-slot-name" data-po-slot-name></span>';
        html += '</label>';
      }
      html += '<span class="po__upload-hint">' + hint + '</span>';
      html += '</div>';
      return html;
    }

    // --- Siirrä Määrä-valitsin optioiden loppuun ---

    function moveQuantityAfterOptions() {
      var quantityEl = document.querySelector('.product-form__quantity, [class*="quantity"][class*="product"]');
      if (!quantityEl || !container) return;
      // Siirretään PO-containerin viimeisen kentän jälkeen (ennen Lisää ostoskoriin -nappia)
      container.after(quantityEl);
    }

    // --- Siirrä natiivi varianttivalitsin (esim. Valokuvakehykset) optioiden jälkeen ---
    // Dawn renderöi varianttivalitsimen normaalisti hinnan alle (ennen lomaketta). Tämä
    // siirtää sen PO-kenttien jälkeen, jotta esim. personointiteksti kysytään ENSIN ja
    // varianttipohjainen lisävalinta (kehykset) vasta lopuksi. No-op jos valitsinta ei ole.
    function moveVariantPickerAfterOptions() {
      if (!container) return;
      var scope = container.closest('product-info') || document;
      var picker = scope.querySelector('variant-selects');
      if (!picker) return;
      if (picker.previousElementSibling === container) return; // jo paikallaan
      container.after(picker);
    }

    // === Multi-select + variantti-/määräpohjainen hinnoittelu (esim. lajittelumerkit) ===

    // Injektoi tyylit kerran (multi-napit + natiivielementtien piilotus)
    function injectPoStyles() {
      if (document.getElementById('po-config-styles')) return;
      var hasMulti = config.fields.some(function (f) { return f.type === 'multi_select'; });
      if (!hasMulti && !config.hideVariantPicker && !config.hideNativePrice && !config.hideQuantity) return;
      var css = ''
        + '.po__multi{display:flex;flex-wrap:wrap;gap:8px}'
        + '.po__multi-all{margin-top:10px;display:inline-block;padding:9px 16px;border:1px dashed #C9A87A;border-radius:10px;background:rgba(201,168,122,.10);color:#7a5c2e;font-size:14px;font-weight:600;cursor:pointer}'
        + '.po__multi-all--active{background:#C9A87A;color:#fff;border-style:solid}'
        + '.po__multi-summary{margin-top:12px;font-size:16px;line-height:1.45}'
        + '.po__multi-summary strong{font-size:19px}'
        + '.po__multi-empty{color:rgba(0,0,0,.55);font-size:14px}'
        + '.po__multi-tip{margin-top:8px;font-size:13px;color:#7a5c2e;background:rgba(242,239,211,.7);padding:7px 11px;border-radius:8px}'
        + '.po-hide-picker variant-selects{display:none !important}'
        + '.po-hide-qty .product-form__quantity{display:none !important}'
        + '.po-hide-price .product__info-container .price{display:none !important}';
      var s = document.createElement('style');
      s.id = 'po-config-styles';
      s.textContent = css;
      document.head.appendChild(s);
    }

    // Esivalitse radio_button-kenttien default-arvot
    function applyDefaults() {
      config.fields.forEach(function (f) {
        if (f.type !== 'radio_button' || !f.default) return;
        state[f.id] = f.default;
        var group = container.querySelector('[data-po-input="' + f.id + '"]');
        if (group) {
          var btns = group.querySelectorAll('[data-po-value]');
          for (var i = 0; i < btns.length; i++) {
            if (btns[i].getAttribute('data-po-value') === f.default) {
              btns[i].classList.add('po__radio-btn--active');
              btns[i].classList.add('po__swatch--active');
              if (btns[i].dataset.poVariant) setVariant(btns[i].dataset.poVariant);
              break;
            }
          }
        }
        syncProperty(f.id);
      });
    }

    // Piilota natiivit elementit (varianttivalitsin/hinta/määrä) config-lippujen mukaan
    function applyUiHides() {
      var anchor = container.closest('product-info') || container.closest('section') || document.body;
      if (config.hideVariantPicker) anchor.classList.add('po-hide-picker');
      if (config.hideNativePrice) anchor.classList.add('po-hide-price');
      if (config.hideQuantity) anchor.classList.add('po-hide-qty');
    }

    // Aseta Dawnin määrä (quantity) -kentän arvo
    function setQuantity(q) {
      var scope = container.closest('product-info') || document;
      var qInput = scope.querySelector('.quantity__input, input[name="quantity"]');
      if (qInput) {
        qInput.value = q;
        qInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    function multiEur(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    // Renderöi multi_select-kenttien napit, "valitse kaikki", summa ja vihje
    function initMultiSelects() {
      config.fields.forEach(function (f) {
        if (f.type !== 'multi_select') return;
        var fieldEl = container.querySelector('[data-po-field="' + f.id + '"]');
        if (!fieldEl) return;
        multiState[f.id] = [];
        var html = '<div class="po__radio-group po__multi" data-po-multi="' + f.id + '">';
        (f.options || []).forEach(function (o) {
          html += '<button type="button" class="po__radio-btn" data-po-multi-value="' + escapeAttr(o.value) + '">' + esc(o.label) + '</button>';
        });
        html += '</div>';
        if (f.setThreshold) {
          html += '<button type="button" class="po__multi-all" data-po-multi-all="' + f.id + '">Valitse kaikki ' + f.setThreshold + ' (setti)</button>';
        }
        html += '<div class="po__multi-summary" data-po-multi-total="' + f.id + '"></div>';
        html += '<div class="po__multi-tip" data-po-multi-hint="' + f.id + '" style="display:none"></div>';
        var hidden = fieldEl.querySelector('[data-po-property="' + f.id + '"]');
        if (hidden) hidden.insertAdjacentHTML('beforebegin', html);
        else fieldEl.insertAdjacentHTML('beforeend', html);
      });
    }

    function toggleMulti(fid, value, btn) {
      var arr = multiState[fid] || (multiState[fid] = []);
      var i = arr.indexOf(value);
      if (i === -1) { arr.push(value); btn.classList.add('po__radio-btn--active'); }
      else { arr.splice(i, 1); btn.classList.remove('po__radio-btn--active'); }
      recomputeMultiSelects();
      evaluateConditions();
    }

    function toggleAllMulti(fid) {
      var f = null;
      config.fields.forEach(function (x) { if (x.id === fid) f = x; });
      if (!f) return;
      var grp = container.querySelector('[data-po-multi="' + fid + '"]');
      var allValues = (f.options || []).map(function (o) { return o.value; });
      var isAll = (multiState[fid] || []).length === allValues.length;
      multiState[fid] = isAll ? [] : allValues.slice();
      var btns = grp.querySelectorAll('[data-po-multi-value]');
      for (var i = 0; i < btns.length; i++) {
        btns[i].classList.toggle('po__radio-btn--active', !isAll);
      }
      recomputeMultiSelects();
      evaluateConditions();
    }

    // Laske multi_select-kentän variantti, määrä, summa ja property
    function recomputeMultiSelects() {
      config.fields.forEach(function (f) {
        if (f.type !== 'multi_select') return;
        var sel = multiState[f.id] || [];
        var count = sel.length;
        var kokoVal = f.variantBy ? state[f.variantBy] : null;
        var pm = (f.priceMap && kokoVal) ? f.priceMap[kokoVal] : null;
        var vm = (f.variantMap && kokoVal) ? f.variantMap[kokoVal] : null;
        var isSet = !!(f.setThreshold && count >= f.setThreshold);
        var mode = isSet ? 'setti' : 'yksittain';
        if (vm && vm[mode]) setVariant(String(vm[mode]));
        if (f.quantityDriven) setQuantity(isSet ? 1 : (count > 0 ? count : 1));
        var totalCents = pm ? (isSet ? pm.set : count * pm.perItem) : 0;
        state[f.id] = count ? (isSet ? (f.setLabel || 'Kaikki') : sel.join(', ')) : '';
        var hidden = container.querySelector('[data-po-property="' + f.id + '"]');
        if (hidden) { hidden.value = state[f.id]; hidden.disabled = !state[f.id]; }
        var allBtn = container.querySelector('[data-po-multi-all="' + f.id + '"]');
        if (allBtn) allBtn.classList.toggle('po__multi-all--active', isSet);
        var totalEl = container.querySelector('[data-po-multi-total="' + f.id + '"]');
        if (totalEl) {
          if (count === 0) {
            totalEl.innerHTML = '<span class="po__multi-empty">' + (pm ? multiEur(pm.perItem) + ' / merkki – valitse vähintään yksi' : 'Valitse vähintään yksi merkki') + '</span>';
          } else if (isSet) {
            totalEl.innerHTML = '🎉 Settietu! Yhteensä <strong>' + multiEur(totalCents) + '</strong> (kaikki ' + count + ' merkkiä)';
          } else {
            totalEl.innerHTML = count + ' merkki' + (count === 1 ? '' : 'ä') + ' × ' + multiEur(pm ? pm.perItem : 0) + ' = <strong>' + multiEur(totalCents) + '</strong>';
          }
        }
        var hintEl = container.querySelector('[data-po-multi-hint="' + f.id + '"]');
        if (hintEl) {
          if (pm && !isSet && f.setThreshold && count >= (f.setThreshold - 2) && count < f.setThreshold) {
            hintEl.textContent = '💡 Kaikki ' + f.setThreshold + ' merkkiä settinä ' + multiEur(pm.set) + ' – usein edullisempi!';
            hintEl.style.display = '';
          } else {
            hintEl.style.display = 'none';
          }
        }
      });
    }

    // --- Renderöi JS:llä lisätyt kentät joita Liquid ei renderöinyt ---

    function renderMissingFields() {
      config.fields.forEach(function (f) {
        if (container.querySelector('[data-po-field="' + f.id + '"]')) return; // jo renderöity
        // Generoi HTML tälle kentälle
        var html = '<div class="po__field" data-po-field="' + f.id + '" data-po-type="' + f.type + '">';
        if (f.label && f.type !== 'personalized_text') {
          html += '<span class="po__label">' + esc(f.label) + '</span>';
        }
        if (f.type === 'file_upload') {
          html += renderFileUploadHTML(f);
        } else if (f.type === 'textarea') {
          html += '<div class="po__text-wrap">';
          html += '<textarea class="po__textarea" data-po-input="' + f.id + '" maxlength="' + (f.maxLength || 200) + '"';
          html += ' rows="' + (f.rows || 3) + '" placeholder="' + escapeAttr(f.placeholder || '') + '"></textarea>';
          if (f.maxLength) html += '<div class="po__char-count" data-po-count="' + f.id + '">0/' + f.maxLength + '</div>';
          html += '</div>';
        }
        if (f.propertyName && f.type !== 'file_upload') {
          html += '<input type="hidden" name="properties[' + escapeAttr(f.propertyName) + ']" value="" data-po-property="' + f.id + '">';
        }
        html += '</div>';

        // Lisää oikeaan kohtaan
        var idx = config.fields.indexOf(f);
        var nextField = config.fields[idx + 1];
        var nextEl = nextField ? container.querySelector('[data-po-field="' + nextField.id + '"]') : null;
        var div = document.createElement('div');
        div.innerHTML = html;
        var newEl = div.firstElementChild;
        if (nextEl) {
          nextEl.before(newEl);
        } else {
          container.appendChild(newEl);
        }
      });
    }

    // --- Vakiokenttien lisäys (liite + lisätiedot) ---

    function injectDefaultFields() {
      if (config.noDefaultFields) return;
      var hasUpload = config.fields.some(function (f) { return f.type === 'file_upload'; });
      var hasLisatiedot = config.fields.some(function (f) { return f.id === 'lisatiedot'; });

      // Lisää liite-kenttä (valinnainen) jos ei jo ole
      if (!hasUpload) {
        var insertIdx = hasLisatiedot
          ? config.fields.findIndex(function (f) { return f.id === 'lisatiedot'; })
          : config.fields.length;
        config.fields.splice(insertIdx, 0, {
          id: '_liite',
          type: 'file_upload',
          label: 'Liitä kuva tai tiedosto (valinnainen)',
          accept: '.jpg,.png,.jpeg,.svg,.pdf',
          maxFiles: 1,
          uploadHint: 'JPG, PNG, PDF tai SVG. Enintään 20 Mt.',
          propertyName: 'Liite'
        });
      }

      // Lisää lisätiedot-kenttä loppuun jos ei jo ole
      if (!hasLisatiedot) {
        config.fields.push({
          id: 'lisatiedot',
          type: 'textarea',
          label: 'Lisätiedot tai toiveet (valinnainen)',
          maxLength: 200,
          rows: 2,
          placeholder: 'esim. Tarvitsen tiettyyn päivään mennessä, erityistoiveet...',
          propertyName: 'Lisätiedot'
        });
      }
    }

    // --- Personalized Text: sisällön renderöinti (ilman ulompaa wrapperia) ---

    function renderPTInnerHTML(f, maxLines, maxLen, previewStyle, fonts) {
      var html = '';
      var lineLabels = Array.isArray(f.lineLabels) ? f.lineLabels : null;
      var showAllLines = f.showAllLines === true;
      var hideLinesPicker = f.hideLinesPicker === true;

      // Tekstikentät
      for (var i = 0; i < maxLines; i++) {
        var isFirst = i === 0;
        var visible = isFirst || showAllLines;
        var hidden = !visible ? ' style="display:none"' : '';
        html += '<div class="po__pt-line" data-po-pt-line="' + i + '"' + hidden + '>';
        html += '<label class="po__label">';
        if (lineLabels && lineLabels[i]) {
          html += esc(lineLabels[i]);
          if (isFirst && f.required) {
            html += '<span class="po__required">*</span>';
          } else if (!isFirst) {
            html += ' <span class="po__help-inline">(valinnainen)</span>';
          }
        } else if (isFirst) {
          html += esc(f.label || 'Kaiverrettava teksti');
          if (f.required) html += '<span class="po__required">*</span>';
        } else {
          html += 'Teksti rivi ' + (i + 1) + ' <span class="po__help-inline">(valinnainen)</span>';
        }
        html += '</label>';
        html += '<input type="text" class="po__input po__pt-input" data-po-pt-text="' + i + '"';
        html += ' maxlength="' + maxLen + '" placeholder="Kirjoita tähän" autocomplete="off"';
        if (isFirst && f.required) html += ' required';
        html += '>';
        html += '<div class="po__char-count" data-po-pt-count="' + i + '">0/' + maxLen + '</div>';
        html += '</div>';
      }

      // Rivimäärävalitsin (piilotettavissa hideLinesPicker-asetuksella)
      if (maxLines > 1 && !hideLinesPicker) {
        html += '<div class="po__pt-rows"><span class="po__label">Tekstirivien määrä</span><div class="po__radio-group">';
        for (var r = 1; r <= maxLines; r++) {
          var active = r === 1 ? ' po__radio-btn--active' : '';
          html += '<button type="button" class="po__radio-btn' + active + '" data-po-pt-lines="' + r + '">' + r + (r === 1 ? ' rivi' : ' riviä') + '</button>';
        }
        html += '</div></div>';
      }

      // Esikatselu
      var style = PREVIEW_STYLES[previewStyle] || PREVIEW_STYLES['gold-on-dark'];
      html += '<div class="po__pt-preview"><span class="po__label">Esikatselu</span>';
      html += '<div class="po__preview-wrap" style="background:' + style.bg + '">';
      html += '<span class="po__preview-placeholder" data-po-pt-placeholder>Kirjoita teksti nähdäksesi esikatselun</span>';
      html += '<svg class="po__preview-svg" data-po-pt-svg style="display:none" xmlns="http://www.w3.org/2000/svg"></svg>';
      html += '</div></div>';

      // Fonttivalitsin
      html += '<div class="po__pt-fonts"><span class="po__label">Valitse fontti<span class="po__required">*</span> <span class="po__font-counter" data-po-pt-counter></span></span>';
      html += '<div class="po__fonts-wrap">';
      html += '<button type="button" class="po__fonts-arrow" data-po-pt-prev aria-label="Edellinen fontti">&#x2039;</button>';
      html += '<div class="po__font-scroll" data-po-pt-fontlist></div>';
      html += '<button type="button" class="po__fonts-arrow" data-po-pt-next aria-label="Seuraava fontti">&#x203A;</button>';
      html += '</div>';
      html += '<p class="po__fonts-hint">Selaa fontteja vierittämällä tai painamalla nuolista</p></div>';

      return html;
    }

    // --- Täydennä tyhjät colorPreset-ryhmät (Liquid renderöi tyhjän swatch-groupin) ---

    function fillEmptyColorPresets() {
      config.fields.forEach(function (f) {
        if (f.type === 'radio_color' && f.options && f.options.length > 0) {
          var group = container.querySelector('[data-po-input="' + f.id + '"]');
          if (group && group.children.length === 0) {
            var html = '';
            f.options.forEach(function (o) {
              var disCls = o.disabled ? ' po__swatch--disabled' : '';
              var disAttr = o.disabled ? ' disabled aria-disabled="true"' : '';
              var disTitle = o.disabled ? (o.label + ' — ei tällä hetkellä saatavilla') : o.label;
              html += '<button type="button" class="po__swatch po__swatch--color' + disCls + '" data-po-value="' + escapeAttr(o.value) + '"' + disAttr;
              html += ' title="' + escapeAttr(disTitle) + '" style="--swatch-color:' + (o.color || '#ccc') + '">';
              html += '<span class="po__color-circle"></span>';
              html += '<span class="po__swatch-name">' + esc(o.label) + '</span></button>';
            });
            group.innerHTML = html;
          }
        }
      });
    }

    // --- Personalized Text: HTML-generointi ---

    function renderPersonalizedTextHTML(f) {
      var maxLines = f.maxLines || 1;
      var maxLen = f.maxLength || 15;
      var preset = f.fontPreset || 'kirjasin-5';
      var previewStyle = f.previewStyle || 'gold-on-dark';
      var lineLabels = Array.isArray(f.lineLabels) ? f.lineLabels : null;
      var showAllLines = f.showAllLines === true;
      var hideLinesPicker = f.hideLinesPicker === true;
      var html = '';

      html += '<div class="po__personalized" data-po-input="' + f.id + '"';
      html += ' data-po-font-preset="' + escapeAttr(preset) + '"';
      html += ' data-po-max-lines="' + maxLines + '"';
      html += ' data-po-max-length="' + maxLen + '"';
      html += ' data-po-preview-style="' + escapeAttr(previewStyle) + '">';

      // Tekstikentät
      for (var i = 0; i < maxLines; i++) {
        var isFirst = i === 0;
        var visible = isFirst || showAllLines;
        var hidden = !visible ? ' style="display:none"' : '';
        html += '<div class="po__pt-line" data-po-pt-line="' + i + '"' + hidden + '>';
        html += '<label class="po__label">';
        if (lineLabels && lineLabels[i]) {
          html += esc(lineLabels[i]);
          if (isFirst && f.required) {
            html += '<span class="po__required">*</span>';
          } else if (!isFirst) {
            html += ' <span class="po__help-inline">(valinnainen)</span>';
          }
        } else if (isFirst) {
          html += esc(f.label || 'Oma teksti');
          if (f.required) html += '<span class="po__required">*</span>';
        } else {
          html += 'Teksti rivi ' + (i + 1) + ' <span class="po__help-inline">(valinnainen)</span>';
        }
        html += '</label>';
        html += '<input type="text" class="po__input po__pt-input" data-po-pt-text="' + i + '"';
        html += ' maxlength="' + maxLen + '" placeholder="Kirjoita tähän" autocomplete="off"';
        if (isFirst && f.required) html += ' required';
        html += '>';
        html += '<div class="po__char-count" data-po-pt-count="' + i + '">0/' + maxLen + '</div>';
        html += '</div>';
      }

      // Rivimäärävalitsin (piilotettavissa hideLinesPicker-asetuksella)
      if (maxLines > 1 && !hideLinesPicker) {
        html += '<div class="po__pt-rows">';
        html += '<span class="po__label">Tekstirivien määrä</span>';
        html += '<div class="po__radio-group">';
        for (var r = 1; r <= maxLines; r++) {
          var active = r === 1 ? ' po__radio-btn--active' : '';
          html += '<button type="button" class="po__radio-btn' + active + '" data-po-pt-lines="' + r + '">';
          html += r + (r === 1 ? ' rivi' : ' riviä');
          html += '</button>';
        }
        html += '</div></div>';
      }

      // Esikatselu (ennen fonttivalitsinta)
      var style = PREVIEW_STYLES[previewStyle] || PREVIEW_STYLES['gold-on-dark'];
      html += '<div class="po__pt-preview">';
      html += '<span class="po__label">Esikatselu</span>';
      html += '<div class="po__preview-wrap" style="background:' + style.bg + '">';
      html += '<span class="po__preview-placeholder" data-po-pt-placeholder>Kirjoita teksti nähdäksesi esikatselun</span>';
      html += '<svg class="po__preview-svg" data-po-pt-svg style="display:none" xmlns="http://www.w3.org/2000/svg"></svg>';
      html += '</div></div>';

      // Fonttivalitsin (nuolilla + laskuri, kuten kakkukoristeessa)
      html += '<div class="po__pt-fonts">';
      html += '<span class="po__label">Valitse fontti<span class="po__required">*</span> <span class="po__font-counter" data-po-pt-counter></span></span>';
      html += '<div class="po__fonts-wrap">';
      html += '<button type="button" class="po__fonts-arrow" data-po-pt-prev aria-label="Edellinen fontti">&#x2039;</button>';
      html += '<div class="po__font-scroll" data-po-pt-fontlist></div>';
      html += '<button type="button" class="po__fonts-arrow" data-po-pt-next aria-label="Seuraava fontti">&#x203A;</button>';
      html += '</div>';
      html += '<p class="po__fonts-hint">Selaa fontteja vierittämällä tai painamalla nuolista</p>';
      html += '</div>';

      html += '</div>';
      return html;
    }

    // --- Varianttien lataus ---

    function loadProductVariants() {
      var url = container.dataset.productUrl;
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.product && data.product.variants) {
            productVariants = {};
            data.product.variants.forEach(function (v) {
              productVariants[String(v.id)] = v;
            });
          }
        })
        .catch(function () {});
    }

    // --- Event binding ---

    function bindEvents() {
      container.addEventListener('click', function (e) {
        var multiBtn = e.target.closest('[data-po-multi-value]');
        if (multiBtn) {
          var mg = multiBtn.closest('[data-po-multi]');
          if (mg) toggleMulti(mg.dataset.poMulti, multiBtn.dataset.poMultiValue, multiBtn);
          return;
        }
        var allBtn = e.target.closest('[data-po-multi-all]');
        if (allBtn) { toggleAllMulti(allBtn.dataset.poMultiAll); return; }
        var btn = e.target.closest('[data-po-value]');
        if (btn) {
          if (btn.disabled || btn.classList.contains('po__swatch--disabled')) return;
          var inputGroup = btn.closest('[data-po-input]');
          if (inputGroup) selectOption(inputGroup.dataset.poInput, btn.dataset.poValue, btn);
        }
      });

      container.addEventListener('input', function (e) {
        var el = e.target;
        if (el.tagName === 'INPUT' && el.type === 'text' && el.dataset.poInput) {
          state[el.dataset.poInput] = el.value;
          updateCharCount(el.dataset.poInput, el);
          syncProperty(el.dataset.poInput);
          evaluateConditions();
        } else if (el.tagName === 'TEXTAREA' && el.dataset.poInput) {
          state[el.dataset.poInput] = el.value;
          updateCharCount(el.dataset.poInput, el);
          syncProperty(el.dataset.poInput);
          evaluateConditions();
        }
      });

      container.addEventListener('change', function (e) {
        if (e.target.classList.contains('po__select') && e.target.dataset.poInput) {
          var sel = e.target;
          state[sel.dataset.poInput] = sel.value;
          var selOpt = sel.options[sel.selectedIndex];
          if (selOpt && selOpt.dataset.poVariant) setVariant(selOpt.dataset.poVariant);
          syncProperty(sel.dataset.poInput);
          syncGalleryToValue(sel.value);
          evaluateConditions();
          updateDisplayedPrice();
          return;
        }
        if (e.target.classList.contains('po__toggle-input')) {
          var wrap = e.target.closest('[data-po-input]');
          if (wrap) {
            state[wrap.dataset.poInput] = e.target.checked;
            syncProperty(wrap.dataset.poInput);
            evaluateConditions();
            updateDisplayedPrice();
          }
        }
        if (e.target.classList.contains('po__upload-input')) {
          var uploadWrap = e.target.closest('[data-po-input]');
          if (uploadWrap) handleFileSelect(uploadWrap.dataset.poInput, e.target);
        }
      });

      // Varianttiehdot: kuuntele natiivin varianttivalitsimen muutoksia dokumenttitasolla
      // (delegoitu — Dawn voi renderöidä valitsimen uudelleen variantin vaihtuessa).
      // Viivästetty uudelleenevaluointi kattaa section-renderin jälkeisen DOM-vaihdon.
      var hasVariantCond = config.fields.some(function (f) {
        return f.condition && f.condition.variantOption;
      });
      if (hasVariantCond) {
        document.addEventListener('change', function (e) {
          var t = e.target;
          if (!t || !t.closest) return;
          if (t.closest('variant-selects') || t.closest('variant-radios')) {
            evaluateConditions();
            setTimeout(evaluateConditions, 350);
          }
        });
      }
    }

    // --- Valinta ---

    function selectOption(fieldId, value, btn) {
      state[fieldId] = value;
      var group = btn.closest('[data-po-input]');
      var buttons = group.querySelectorAll('[data-po-value]');
      for (var i = 0; i < buttons.length; i++) {
        var isActive = buttons[i] === btn;
        buttons[i].classList.toggle('po__radio-btn--active', isActive);
        buttons[i].classList.toggle('po__swatch--active', isActive);
      }
      if (btn.dataset.poVariant) setVariant(btn.dataset.poVariant);
      syncProperty(fieldId);
      syncGalleryToValue(value);
      evaluateConditions();
      updateDisplayedPrice();
      recomputeMultiSelects();
    }

    // Synkronoi tuotegalleria valittuun swatch-arvoon:
    // klikkaa thumbnail-buttonia jonka alt-teksti sisältää arvon (esim. "Malli 1").
    function syncGalleryToValue(value) {
      if (!value) return;
      var thumbs = document.querySelectorAll('media-gallery .thumbnail-list__item button.thumbnail');
      if (!thumbs.length) {
        thumbs = document.querySelectorAll('.thumbnail-list__item button.thumbnail');
      }
      var needle = String(value).toLowerCase();
      for (var i = 0; i < thumbs.length; i++) {
        var img = thumbs[i].querySelector('img');
        var alt = (img && img.alt ? img.alt : thumbs[i].getAttribute('aria-label') || '').toLowerCase();
        if (alt.indexOf(needle) !== -1) {
          if (thumbs[i].getAttribute('aria-current') === 'true') return;
          thumbs[i].click();
          return;
        }
      }
    }

    // --- Variantti ---

    function setVariant(variantId) {
      var form = container.closest('form');
      var input = form ? form.querySelector('.product-variant-id, input[name="id"]') : null;
      if (input) {
        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (typeof window.history !== 'undefined') {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }
    }

    // --- Hinta ---

    function updateDisplayedPrice() {
      var addonTotal = 0;
      config.fields.forEach(function (f) {
        if (!isFieldVisible(f)) return;
        if (f.type === 'toggle' && state[f.id] && f.priceAddon) addonTotal += f.priceAddon;
        if (f.options) {
          f.options.forEach(function (o) {
            if (o.value === state[f.id] && o.priceAddon && !o.variantId) addonTotal += o.priceAddon;
          });
        }
      });
      var infoEl = container.querySelector('.po__addon-info');
      if (addonTotal > 0) {
        if (!infoEl) {
          infoEl = document.createElement('div');
          infoEl.className = 'po__addon-info';
          container.appendChild(infoEl);
        }
        infoEl.textContent = 'Valinta lisää €' + (addonTotal / 100).toFixed(2).replace('.', ',') + ' hintaan';
        infoEl.style.display = '';
      } else if (infoEl) {
        infoEl.style.display = 'none';
      }
    }

    // --- Ehdollisuus ---

    function evaluateConditions() {
      config.fields.forEach(function (f) {
        var el = container.querySelector('[data-po-field="' + f.id + '"]');
        if (!el || !f.condition) return;
        var visible = checkCondition(f.condition);
        el.style.display = visible ? '' : 'none';
        // Hidden conditional controls must not be submitted or block native validation.
        el.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach(function (control) {
          control.disabled = !visible;
        });
        if (!visible && state[f.id]) {
          clearFieldState(f, el);
          syncProperty(f.id);
        }
      });
    }

    function checkCondition(cond) {
      // condition.variantOption lukee natiivin varianttivalitsimen valintaa
      // (esim. {"variantOption":"Väri","operator":"contains","value":"Muu väri"});
      // ilman sitä ehto lukee toisen po-kentän tilaa (condition.field).
      var val = cond.variantOption ? getNativeOptionValue(cond.variantOption) : state[cond.field];
      var op = cond.operator || 'eq';
      var target = cond.value;
      if (op === 'eq') {
        if (target === true || target === 'On') return val === true || val === 'On';
        return String(val) === String(target);
      }
      if (op === 'neq') return String(val) !== String(target);
      if (op === 'truthy') return !!val;
      if (op === 'in') return Array.isArray(target) && target.indexOf(String(val)) !== -1;
      if (op === 'contains') return String(val).indexOf(String(target)) !== -1;
      return String(val) === String(target);
    }

    // Natiivin varianttivalitsimen valittu arvo option nimellä. Dawn renderöi
    // pillit/swatchit radioina name="<Optio>-<positio>" ja dropdownin
    // selectinä name="options[<Optio>]" — luetaan kummastakin.
    function getNativeOptionValue(optionName) {
      var scope = container.closest('product-info') || container.closest('section') || document;
      var sel = scope.querySelector('select[name="options[' + optionName + ']"]');
      if (sel) return sel.value;
      var radios = scope.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].checked && radios[i].name.indexOf(optionName + '-') === 0) return radios[i].value;
      }
      return '';
    }

    function isFieldVisible(f) {
      return !f.condition || checkCondition(f.condition);
    }

    function clearFieldState(f, el) {
      if (f.type === 'toggle') {
        state[f.id] = false;
        var cb = el.querySelector('.po__toggle-input');
        if (cb) cb.checked = false;
      } else {
        state[f.id] = '';
        var inp = el.querySelector('input.po__input, textarea.po__textarea');
        if (inp) inp.value = '';
        var sel = el.querySelector('select.po__select');
        if (sel) sel.selectedIndex = 0;
        var actives = el.querySelectorAll('.po__radio-btn--active, .po__swatch--active');
        for (var i = 0; i < actives.length; i++) {
          actives[i].classList.remove('po__radio-btn--active', 'po__swatch--active');
        }
      }
    }

    // --- Properties ---

    function syncProperty(fieldId) {
      var input = container.querySelector('[data-po-property="' + fieldId + '"]');
      if (!input) return;
      var val = state[fieldId];
      if (typeof val === 'boolean') {
        input.value = val ? 'Kyllä' : '';
      } else {
        input.value = val || '';
      }
      input.disabled = !input.value;
      // Fontti-property seuraa tekstiä: ilman tekstiä fonttia ei lähetetä tilaukselle.
      // Ilman tätä Liquidin renderöimä tyhjä Fontti-input jää enabloiduksi initissä
      // ja tilausriville päätyy "Fontti: " -roska.
      var fontInput = container.querySelector('[data-po-property="' + fieldId + '__font"]');
      if (fontInput) {
        fontInput.value = state[fieldId + '__font'] || '';
        fontInput.disabled = !input.value || !fontInput.value;
      }
    }

    function syncAllProperties() {
      config.fields.forEach(function (f) {
        if (f.type === 'file_upload') return; // file_upload ei käytä hidden propertyä
        syncProperty(f.id);
      });
    }

    // --- Merkkimäärä ---

    function updateCharCount(fieldId, inputEl) {
      var el = container.querySelector('[data-po-count="' + fieldId + '"]');
      if (!el) return;
      el.textContent = inputEl.value.length + '/' + (inputEl.maxLength || 100);
    }

    // --- Tiedostot ---
    // Shopify lataa tiedoston suoraan line item propertyyn (input[type=file] name="properties[...]").
    // Täällä vain päivitetään UI näyttämään tiedoston nimi — ei synkronoida arvoa hidden inputtiin.

    function handleFileSelect(fieldId, inputEl) {
      var slot = inputEl.closest('.po__upload-area');
      if (!slot) return;
      var nameEl = slot.querySelector('[data-po-slot-name]');
      var file = inputEl.files && inputEl.files[0];
      if (!file) {
        if (nameEl) nameEl.textContent = '';
        slot.classList.remove('po__upload-area--filled');
        return;
      }
      var size = file.size;
      var sizeStr = size < 1024 ? size + ' B'
                  : size < 1048576 ? (size / 1024).toFixed(1) + ' KB'
                  : (size / 1048576).toFixed(1) + ' Mt';
      if (nameEl) nameEl.textContent = file.name + ' (' + sizeStr + ')';
      slot.classList.add('po__upload-area--filled');
    }

    // --- Personalized Text: alustus ja interaktio ---

    function initPersonalizedTexts() {
      var ptFields = container.querySelectorAll('.po__personalized');
      for (var i = 0; i < ptFields.length; i++) {
        initPT(ptFields[i]);
      }
    }

    function initPT(ptEl) {
      var fieldId = ptEl.dataset.poInput;
      var preset = ptEl.dataset.poFontPreset || 'kaiverrettavat';
      var maxLines = parseInt(ptEl.dataset.poMaxLines) || 1;
      var maxLen = parseInt(ptEl.dataset.poMaxLength) || 15;
      var previewStyle = ptEl.dataset.poPreviewStyle || 'gold-on-dark';

      // Hae fontit presetistä tai kentän custom-fonteista
      var field = config.fields.find(function (f) { return f.id === fieldId; });
      var fonts = field && field.fonts ? field.fonts : (FONT_PRESETS[preset] || FONT_PRESETS['kaiverrettavat']);

      // Täytä sisältö jos Liquid renderöi tyhjän containerin
      if (ptEl.children.length === 0 && field) {
        ptEl.innerHTML = renderPTInnerHTML(field, maxLines, maxLen, previewStyle, fonts);
      }

      var showAllLines = field && field.showAllLines === true;
      var ptState = {
        texts: [],
        lines: showAllLines ? maxLines : 1,
        font: null,
      };
      for (var i = 0; i < maxLines; i++) ptState.texts.push('');

      // State-viittaus päätiloihin
      state[fieldId] = '';
      state[fieldId + '__font'] = '';

      // Renderöi fonttinapit (live-fonteilla, kuten kakkukoristeessa)
      var fontList = ptEl.querySelector('[data-po-pt-fontlist]');
      if (fontList) {
        var html = '<button type="button" class="po__font-btn po__font-btn--active" data-po-pt-font="-1" aria-pressed="true">Valitse fontti</button>';
        for (var fi = 0; fi < fonts.length; fi++) {
          var font = fonts[fi];
          var activeClass = '';
          var extraStyle = font.family.indexOf('variable') !== -1 ? ";font-variation-settings:'wght' 400" : '';
          html += '<button type="button" class="po__font-btn' + activeClass + '" data-po-pt-font="' + fi + '" aria-pressed="false">';
          html += '<span class="po__font-preview" style="font-family:\'' + escapeAttr(font.family) + '\',sans-serif' + extraStyle + '">';
          html += esc('Esimerkki');
          html += '</span>';
          html += '<span class="po__font-name">' + esc(font.label) + '</span>';
          html += '</button>';
        }
        fontList.innerHTML = html;
        updatePTCounter(ptEl, -1, fonts.length);
      }

      // Eventit: tekstikentät
      ptEl.addEventListener('input', function (e) {
        var input = e.target.closest('[data-po-pt-text]');
        if (!input) return;
        var idx = parseInt(input.dataset.poPtText);
        ptState.texts[idx] = input.value;
        // Päivitä merkkimäärä
        var countEl = ptEl.querySelector('[data-po-pt-count="' + idx + '"]');
        if (countEl) countEl.textContent = input.value.length + '/' + maxLen;
        // Päivitä fonttinappien live-teksti
        updatePTFontPreviews(ptEl, ptState);
        updatePTPreview(ptEl, ptState, previewStyle);
        syncPTProperties(fieldId, ptState, maxLines);
      });

      // Nuolipainikkeet ‹ ›
      var prevArrow = ptEl.querySelector('[data-po-pt-prev]');
      var nextArrow = ptEl.querySelector('[data-po-pt-next]');
      function selectFontByIdx(idx) {
        if (idx < 0) idx = fonts.length - 1;
        if (idx >= fonts.length) idx = 0;
        var btn = fontList.querySelector('[data-po-pt-font="' + idx + '"]');
        if (btn) {
          btn.click();
          btn.scrollIntoView({ inline: 'center', behavior: 'smooth', block: 'nearest' });
        }
      }
      function currentFontIdx() {
        var active = fontList.querySelector('.po__font-btn--active');
        return active ? parseInt(active.dataset.poPtFont) : -1;
      }
      if (prevArrow) prevArrow.addEventListener('click', function () { selectFontByIdx(currentFontIdx() - 1); });
      if (nextArrow) nextArrow.addEventListener('click', function () { selectFontByIdx(currentFontIdx() + 1); });

      // Eventit: fonttinapit
      ptEl.addEventListener('click', function (e) {
        var fontBtn = e.target.closest('[data-po-pt-font]');
        if (fontBtn) {
          var idx = parseInt(fontBtn.dataset.poPtFont);
          ptState.font = fonts[idx] || null;
          var allBtns = ptEl.querySelectorAll('[data-po-pt-font]');
          for (var b = 0; b < allBtns.length; b++) {
            var selected = parseInt(allBtns[b].dataset.poPtFont, 10) === idx;
            allBtns[b].classList.toggle('po__font-btn--active', selected);
            allBtns[b].setAttribute('aria-pressed', String(selected));
          }
          updatePTCounter(ptEl, idx, fonts.length);
          updatePTPreview(ptEl, ptState, previewStyle);
          syncPTProperties(fieldId, ptState, maxLines);
          return;
        }

        // Rivimääränapit
        var linesBtn = e.target.closest('[data-po-pt-lines]');
        if (linesBtn) {
          var newLines = parseInt(linesBtn.dataset.poPtLines);
          ptState.lines = newLines;
          // Näytä/piilota rivit
          for (var li = 0; li < maxLines; li++) {
            var lineEl = ptEl.querySelector('[data-po-pt-line="' + li + '"]');
            if (lineEl) {
              lineEl.style.display = li < newLines ? '' : 'none';
              if (li >= newLines) {
                ptState.texts[li] = '';
                var inp = lineEl.querySelector('.po__pt-input');
                if (inp) inp.value = '';
              }
            }
          }
          // Active-luokka
          var rowBtns = ptEl.querySelectorAll('[data-po-pt-lines]');
          for (var rb = 0; rb < rowBtns.length; rb++) {
            rowBtns[rb].classList.toggle('po__radio-btn--active', parseInt(rowBtns[rb].dataset.poPtLines) === newLines);
          }
          updatePTPreview(ptEl, ptState, previewStyle);
          syncPTProperties(fieldId, ptState, maxLines);
        }
      });

      // Alkuesikatselu
      updatePTPreview(ptEl, ptState, previewStyle);
    }

    function updatePTCounter(ptEl, idx, total) {
      var counter = ptEl.querySelector('[data-po-pt-counter]');
      if (counter) counter.textContent = idx >= 0 ? (idx + 1) + ' / ' + total : 'Valitse fontti';
    }

    function updatePTFontPreviews(ptEl, ptState) {
      var displayText = ptState.texts[0] || 'Puuki';
      var previews = ptEl.querySelectorAll('.po__font-preview');
      for (var i = 0; i < previews.length; i++) {
        previews[i].textContent = displayText;
      }
    }

    function updatePTPreview(ptEl, ptState, previewStyle) {
      var svg = ptEl.querySelector('[data-po-pt-svg]');
      var placeholder = ptEl.querySelector('[data-po-pt-placeholder]');
      if (!svg) return;

      var activeTexts = ptState.texts.slice(0, ptState.lines).filter(function (t) { return t.trim(); });
      var fontFamily = ptState.font ? ptState.font.family : 'sans-serif';
      var style = PREVIEW_STYLES[previewStyle] || PREVIEW_STYLES['gold-on-dark'];

      if (activeTexts.length === 0 || !ptState.font) {
        svg.style.display = 'none';
        if (placeholder) {
          placeholder.style.display = '';
          placeholder.textContent = activeTexts.length ? 'Valitse fontti nähdäksesi esikatselun' : 'Kirjoita teksti nähdäksesi esikatselun';
        }
        return;
      }

      svg.style.display = '';
      if (placeholder) placeholder.style.display = 'none';

      var vbW = 400;
      var lh = 55;
      var tp = 10;
      var vbH = tp + activeTexts.length * lh + 5;

      svg.setAttribute('viewBox', '0 0 ' + vbW + ' ' + vbH);

      var html = '';
      for (var j = 0; j < activeTexts.length; j++) {
        var yy = tp + (j + 1) * lh - 8;
        var fs = ptCalcFontSize(activeTexts[j], vbW, 52);
        html += '<text x="' + (vbW / 2) + '" y="' + yy + '" ';
        html += 'text-anchor="middle" ';
        html += 'font-family="\'' + escapeAttr(fontFamily) + '\',sans-serif" ';
        html += 'font-size="' + fs + '" ';
        html += 'fill="' + style.fill + '">';
        html += esc(activeTexts[j]);
        html += '</text>';
      }

      svg.innerHTML = html;
    }

    function ptCalcFontSize(text, viewBoxWidth, base) {
      var maxWidth = viewBoxWidth - 40;
      var charWidth = base * 0.52;
      var estimated = text.length * charWidth;
      if (estimated > maxWidth) return Math.floor(base * (maxWidth / estimated));
      return base;
    }

    function syncPTProperties(fieldId, ptState, maxLines) {
      // Teksti-property: kaikki rivit yhdistettynä
      var allText = ptState.texts.slice(0, ptState.lines).filter(function (t) { return t.trim(); }).join(' | ');
      state[fieldId] = allText;

      var textProp = container.querySelector('[data-po-property="' + fieldId + '"]');
      if (textProp) {
        textProp.value = allText;
        textProp.disabled = !allText;
      }

      // Fontti-property — lähetetään vain kun tekstiäkin on (muuten tilaukselle menisi pelkkä fontti)
      state[fieldId + '__font'] = ptState.font ? ptState.font.label : '';
      var fontProp = container.querySelector('[data-po-property="' + fieldId + '__font"]');
      if (fontProp) {
        fontProp.value = ptState.font ? ptState.font.label : '';
        fontProp.disabled = !allText || !ptState.font;
      }
    }

    // --- Validointi ---

    function validateForm() {
      var firstErr = null;
      var fontError = false;
      hideAllErrors();
      config.fields.forEach(function (f) {
        if (!isFieldVisible(f)) return;
        var val = state[f.id];
        var missingFont = f.type === 'personalized_text' && !!String(val || '').trim() && !state[f.id + '__font'];
        if (!f.required && !missingFont) return;
        if (f.type === 'file_upload') {
          var file = container.querySelector('[data-po-field="' + f.id + '"] input[type="file"]');
          val = file && file.files && file.files.length > 0;
        }
        if (missingFont || !val || (typeof val === 'string' && !val.trim())) {
          var el = container.querySelector('[data-po-field="' + f.id + '"]');
          if (el) {
            el.classList.add('po__field--error');
            if (!firstErr) { firstErr = el; fontError = missingFont; }
          }
        }
      });
      if (firstErr) {
        firstErr.scrollIntoView({ behavior: 'smooth', block: 'center' });
        showError(fontError ? 'Valitse tekstille fontti ennen ostoskoriin lisäämistä.' : 'Täytä kaikki pakolliset kentät ennen ostoskoriin lisäämistä.');
        return false;
      }
      return true;
    }

    function showError(msg) {
      var el = container.querySelector('.po__error');
      if (!el) {
        el = document.createElement('div');
        el.className = 'po__error';
        container.insertBefore(el, container.firstChild);
      }
      el.textContent = msg;
      el.style.display = '';
    }

    function hideAllErrors() {
      var err = container.querySelector('.po__error');
      if (err) err.style.display = 'none';
      var errs = container.querySelectorAll('.po__field--error');
      for (var i = 0; i < errs.length; i++) errs[i].classList.remove('po__field--error');
    }
  }

  // --- Fonttipresetit (Adobe Typekit / stx6weu.css) ---

  // --- Fonttipresetit (Adobe Typekit / stx6weu.css) ---
  // Kaksi pääsarjaa: kakkukoristefontit (kaikki script-fontit) ja kaiverrettavat (sopivat puuhun/metalliin)

  var FONT_PRESETS = {
    'kakkukoristefontit': [
      { family: 'gelato-fresco-variable', label: 'Gelato Fresco' },
      { family: 'quayside', label: 'Quayside' },
      { family: 'limon-script', label: 'Limon Script' },
      { family: 'cinema-script', label: 'Cinema Script' },
      { family: 'swingdancer', label: 'Swingdancer' },
      { family: 'coniferous', label: 'Coniferous' },
      { family: 'lemongrass-script', label: 'Lemongrass Script' },
      { family: 'beloved-script', label: 'Beloved Script' },
      { family: 'goodlife-script', label: 'Goodlife Script' },
      { family: 'liebelotte', label: 'LiebeLotte' },
      { family: 'fig-script', label: 'FIG Script' },
      { family: 'santelia-script', label: 'Santelia Script' },
      { family: 'look-script', label: 'Look Script' },
      { family: 'brooklyn-heritage-script', label: 'Brooklyn Heritage' },
      { family: 'pauline-script', label: 'Pauline Script' },
      { family: 'boucherie-cursive', label: 'Boucherie Cursive' },
      { family: 'relation-one', label: 'Relation One' },
      { family: 'relation-two', label: 'Relation Two' },
      { family: 'benda', label: 'Benda' },
      { family: 'finlay', label: 'Finlay' },
      { family: 'pf-signskript', label: 'PF Signskript' },
      { family: 'dream-big-wide', label: 'Dream Big Wide' },
      { family: 'wreath', label: 'Wreath' },
      { family: 'filmotype-keynote', label: 'Filmotype Keynote' },
      { family: 'mr-rafkin', label: 'Mr Rafkin' },
      { family: 'adage-script-jf', label: 'Adage Script' },
      { family: 'liza-display-new', label: 'Liza Display' },
      { family: 'mrdafoe-pro', label: 'Mr Dafoe' },
    ],
    'kaiverrettavat': [
      // Kitissä (obp5hkn) olevat fontit
      { family: 'alex-brush', label: 'Alex Brush' },
      { family: 'shelby', label: 'Shelby' },
      { family: 'professor', label: 'Professor' },
      { family: 'blithe', label: 'Blithe' },
      { family: 'bebas-neue', label: 'Bebas Neue' },
      { family: 'rockwell', label: 'Rockwell' },
      { family: 'arboria', label: 'Arboria' },
      { family: 'liebelotte', label: 'LiebeLotte' },
      { family: 'liebelotte-swell', label: 'LiebeLotte Swell' },
      { family: 'moonblossom', label: 'Moonblossom' },
      { family: 'gintronic', label: 'Gintronic' },
      { family: 'dreaming-outloud-script', label: 'Dreaming Outloud' },
      { family: 'dreaming-outloud-sans', label: 'Dreaming Sans' },
      { family: 'playpen-sans', label: 'Playpen Sans' },
      // TODO: lisää kittiin fonts.adobe.com:ssa, sitten kommentti pois:
      // { family: 'beloved-script', label: 'Beloved Script' },
      // { family: 'fairwater-script', label: 'Fairwater Script' },
      // { family: 'fabiola-script', label: 'Fabiola Script' },
      // { family: 'skippy-sharp', label: 'Skippy Sharp' },
      // { family: 'marvin-round', label: 'Marvin Round' },
      // { family: 'chelsea-market-pro', label: 'Chelsea Market Pro' },
      // { family: 'scandia-web', label: 'Scandia' },
    ],
    'avaimenperat': [
      { family: 'brothers', label: 'Brothers' },
      { family: 'social-gothic', label: 'Social Gothic' },
      { family: 'social-gothic-soft', label: 'Social Gothic Soft' },
      { family: 'nougat-script', label: 'Nougat Script' },
      { family: 'marvin', label: 'Marvin' },
      { family: 'marvin-round', label: 'Marvin Round' },
      { family: 'jaf-domus-titling-web', label: 'Domus Titling' },
      { family: 'stop-mn', label: 'Stop' },
      { family: 'impact', label: 'Impact' },
      { family: 'yerk', label: 'Yerk' },
      { family: 'ccmeanwhile', label: 'Meanwhile' },
      { family: 'social-gothic-stencil', label: 'Gothic Stencil' },
    ],
  };

  // --- Väripresetit ---

  var COLOR_PRESETS = {
    'koivu-noki': [
      { value: 'Koivu', label: 'Koivu', color: '#EADFCB' },
      { value: 'Noki', label: 'Noki', color: '#2B2B2B' },
    ],
    'muovikyltit': [
      { value: 'Keltainen-musta', label: 'Keltainen-musta', color: '#FFD700' },
      { value: 'Musta-valkoinen', label: 'Musta-valkoinen', color: '#2B2B2B' },
      { value: 'Punainen-valkoinen', label: 'Punainen-valkoinen', color: '#DC143C' },
      { value: 'Sininen-valkoinen', label: 'Sininen-valkoinen', color: '#4169E1' },
      { value: 'Vihreä-valkoinen', label: 'Vihreä-valkoinen', color: '#228B22' },
      { value: 'Valkoinen-musta', label: 'Valkoinen-musta', color: '#F5F5F5' },
    ],
    'metalli-4': [
      { value: 'Hopea', label: 'Hopea', color: '#C0C0C0' },
      { value: 'Kulta', label: 'Kulta', color: '#D4AF37' },
      { value: 'Ruusukulta', label: 'Ruusukulta', color: '#B76E79' },
      { value: 'Musta', label: 'Musta', color: '#070707' },
    ],
    'pullot': [
      { value: 'Vaaleansininen', label: 'Vaaleansininen', color: '#87CEEB' },
      { value: 'Tummapinkki', label: 'Tummapinkki', color: '#C71585' },
      { value: 'Oliivinvihreä', label: 'Oliivinvihreä', color: '#6B8E23' },
      { value: 'Persikkapinkki', label: 'Persikkapinkki', color: '#FFDAB9' },
      { value: 'Petrooli', label: 'Petrooli', color: '#008080' },
      { value: 'Violetti', label: 'Violetti', color: '#8B008B' },
      { value: 'Oranssi', label: 'Oranssi', color: '#FF8C00' },
      { value: 'Sitruunankeltainen', label: 'Sitruunankeltainen', color: '#FFF44F' },
      { value: 'Musta', label: 'Musta', color: '#1a1a1a' },
      { value: 'Punainen', label: 'Punainen', color: '#DC143C' },
    ],
    'korvikset-6': [
      { value: 'Koivu', label: 'Koivu', color: '#EADFCB' },
      { value: 'Noki', label: 'Noki', color: '#2B2B2B' },
      { value: 'Punainen', label: 'Punainen', color: '#DC143C' },
      { value: 'Oranssi', label: 'Oranssi', color: '#FF8C00' },
      { value: 'Lumi', label: 'Lumi', color: '#FFFAFA' },
      { value: 'Vihreä', label: 'Vihreä', color: '#228B22' },
    ],
  };

  var PREVIEW_STYLES = {
    'gold-on-dark': { fill: '#c9a84c', bg: '#1a1a1a' },
    'dark-on-light': { fill: '#1a1a1a', bg: '#fafafa' },
    'engrave': { fill: '#8B6914', bg: '#EADFCB' },
  };

  // --- Apufunktiot ---

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function escapeAttr(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // --- Init ---

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
